import { descriviCosto, formattaCosto, nomeVoceCosto, totaliPerValuta } from './Functions'
import { Dialog } from './Overlay'
import { t } from './testi'

/**
 * Il costo del periodo ripartito per modello e provider.
 * @param {Object} props - Proprietà
 * @param {Array<Object>} props.costi - Le voci di costo
 * @param {() => void} props.onClose - Chiusura
 */
export const DialogCosto = ({ costi, onClose }) => (
  <Dialog
    id="ae-costo"
    titolo={t.aeCostoDettaglio}
    sottotitolo={descriviCosto(totaliPerValuta(costi))}
    chiudiEtichetta={t.aeChiudiForm}
    onClose={onClose}
  >
    <div className="ae-dialog__corpo">
      {costi.some((v) => v.voce) ? (
        <ul className="ae-costo-voci">
          {costi
            .filter((v) => v.voce)
            .map((v) => (
              <li key={`${v.valuta}-${v.voce}`}>
                <span>{nomeVoceCosto(v.voce)}</span>
                <span>{formattaCosto(v.totale, v.valuta)}</span>
              </li>
            ))}
        </ul>
      ) : (
        <p className="ae-muto">{t.aeCostoSenzaDettaglio}</p>
      )}
    </div>
  </Dialog>
)
